export default __webpack_public_path__ + "static/media/218.6720ad57.jpg";